import React, { useState } from "react";

import swal from "sweetalert";
import {
  Form,
  Input,
  FormField,
  FormGroup,
  Button,
  Checkbox,
} from "semantic-ui-react";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Footer from "../../../../components/Footer";

import { producaov2 } from "../../../../services/apis";

import { Container, Box, Header, FormBlock, Notes } from "./styles";

const RelatorioInadimplentes = () => {
  document.title = "Painel Administrativo | Grupo Voitto";

  const [dataInicio, setDataInicio] = useState("");
  const [dataFinal, setDataFinal] = useState("");
  const [reportLink, setReportLink] = useState(null);
  const [loading, setLoading] = useState(false);
  const [reportLinkV2, setReportLinkV2] = useState(null);
  const [loadingV2, setLoadingV2] = useState(false);

  const generateReport = async () => {
    if (!dataInicio || !dataFinal) {
      return swal(
        "Período da pesquisa obrigatório",
        "Atualize o período do relatório e tente novamente",
        "warning"
      );
    }

    setLoading(true);

    try {
      const response = await producaov2.post("/admin/reports/inadimplentes", {
        initialDate: new Date(dataInicio),
        finalDate: new Date(dataFinal),
      });

      setReportLink(response.data.url);
    } catch (error) {
      swal(
        "Houve um erro ao gerar o relatorio",
        "Contate TI para verificar o problema",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const generateReportV2 = async () => {
    if (!dataInicio || !dataFinal) {
      return swal(
        "Período da pesquisa obrigatório",
        "Atualize o período do relatório e tente novamente",
        "warning"
      );
    }

    setLoadingV2(true);

    try {
      const response = await producaov2.post(
        "/admin/reports/inadimplentes-v2",
        {
          initialDate: new Date(dataInicio),
          finalDate: new Date(dataFinal),
        }
      );

      setReportLinkV2(response.data.url);
    } catch (error) {
      swal(
        "Houve um erro ao gerar o relatorio",
        "Contate TI para verificar o problema",
        "error"
      );
    } finally {
      setLoadingV2(false);
    }
  };

  const handleDownloadReport = () => {
    setReportLink(null);
  };

  const handleDownloadReportV2 = () => {
    setReportLinkV2(null);
  };

  return (
    <div style={{ width: "100vw", paddingLeft: "250px" }}>
      <AdminMenu />
      <Container>
        <Header>Relatório de Inadimplentes</Header>
        <Box>
          <Form>
            <FormBlock>
              <p>Selecionar período</p>
              <FormField>
                A partir de
                <Input
                  onChange={(e) => setDataInicio(e.target.value)}
                  type="date"
                />
                até
                <Input
                  onChange={(e) => setDataFinal(e.target.value)}
                  type="date"
                />
              </FormField>
            </FormBlock>

            <FormGroup>
              <div title="Relatório antigo de inadimplência. Pode ser usado para verificar os dados do novo. Será removido no futuro">
                {reportLink ? (
                  <Button
                    as="a"
                    href={reportLink}
                    onClick={handleDownloadReport}
                    style={{ minWidth: "80px" }}
                    color="green"
                  >
                    Baixar Relatório Antigo
                  </Button>
                ) : (
                  <Button
                    color="orange"
                    basic
                    onClick={generateReport}
                    loading={loading}
                  >
                    Gerar Relatório Antigo
                  </Button>
                )}
              </div>
              <div title="Novo relatório de inadimplência">
                {reportLinkV2 ? (
                  <Button
                    as="a"
                    href={reportLinkV2}
                    onClick={handleDownloadReportV2}
                    style={{ minWidth: "80px" }}
                    color="green"
                  >
                    Baixar Relatório
                  </Button>
                ) : (
                  <Button
                    color="orange"
                    onClick={generateReportV2}
                    loading={loadingV2}
                  >
                    Gerar Relatório
                  </Button>
                )}
              </div>
            </FormGroup>
          </Form>
        </Box>
      </Container>
      <Footer />
    </div>
  );
};

export default RelatorioInadimplentes;
